import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
  standalone: false,
  selector: 'sbnb-dialog-statements-edit-commission',
  template: `
    <div class="dialog__container">
      <div class="dialog__header flex justify-between">
        <h3 class="nomargin">Save changes to this commission?</h3>
        <sbnb-close (click)="dialogRef.close()"></sbnb-close>
      </div>
      <div class="flex flex-col gap-3">
        <p>These changes will be applied to future generated statements and open statements using this commission.</p>
        <div class="flex justify-between">
          <sbnb-button type="secondary" label="Cancel" (click)="dialogRef.close()"></sbnb-button>
          <sbnb-button label="Save" (click)="dialogRef.close('save')"></sbnb-button>
        </div>
      </div>
    </div>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogStatementsEditCommissionComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<DialogStatementsEditCommissionComponent>) { }

  ngOnInit(): void { }
}
